import { CombinedGraphQLErrors } from '@apollo/client/errors';

export type UserErrorShape = { code: string; message: string; field?: readonly string[] | null };

/** The `extensions.code` of the first GraphQL error, never the message text. */
export function graphQLErrorCode(error: unknown): string | undefined {
  if (!CombinedGraphQLErrors.is(error)) return undefined;
  const code = error.errors[0]?.extensions?.code;
  return typeof code === 'string' ? code : undefined;
}

/** The first expected business outcome a mutation payload reported, if any. */
export function firstUserErrorCode(
  userErrors: readonly UserErrorShape[] | null | undefined,
): string | null {
  return userErrors?.[0]?.code ?? null;
}

/** A raw error is never shown: offline and server failures get their own short copy. */
export function friendlyErrorMessage(error: unknown): string {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'You are offline. Check the connection and try again.';
  }
  if (CombinedGraphQLErrors.is(error)) return 'Something went wrong on our side. Try again.';
  return 'Macswarm could not be reached. Try again in a moment.';
}
